import React, { useState } from 'react'
import { Grid, CircularProgress, Typography, Divider, Card, useTheme, useMediaQuery, List, ListItem, ListItemText } from '@material-ui/core'
import { Page, Header, SecaoGenerica, ModalConfirmacao, CustomButton, FormLocalColeta } from 'components'
import { useAuth } from 'hooks/useAuth'
import { FileManager } from 'components/FileManager'
import { getLabelEndereco } from 'helpers/labels'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import { useFormEditarVestigio } from './hooks/useFormEditarVestigio'
import { FormDadosEntrada } from './components/FormDadosEntrada'
import { FormCadeiaCustodia } from './components/FormCadeiaCustodia'
import { FormCaracteristicasVestigio } from './components/FormCaracteristicasVestigio'
import useStyles from './FormEditarVestigio.styles'

export const FormEditarVestigio = (props) => {
  const { route } = props
  const classes = useStyles()
  const params = useParams()
  const router = useRouter()
  const { currentUser } = useAuth()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  // Consumindo o Hook Customizado unificado com todos os estados e buscas
  const {
    processandoVestigio,
    setArquivos,
    arquivosIniciais,
    values,
    touched,
    errors,
    isFormularioInvalido,
    caracteristicasVestigio,
    usuarios,
    processandoUsuarios,
    tiposVestigios,
    processandoTiposVestigios,
    processandoTiposVestigiosEspecificos,
    opcoesTiposVestigiosEspecificosAtual,
    processandoOperacao,
    openEspelhoConfirmacao,
    setOpenEspelhoConfirmacao,
    openDeletarVestigio,
    setOpenDeletarVestigio,
    lacreAtualHabilitado,

    // Handlers
    handleChange,
    handleChangeWithModification,
    handleChangeNewValueByNameProperty,
    handleChangeCampoData,
    handleBlur,
    handleChangeTipoVestigioGenerica,

    // Características
    adicionarCaracteristica,
    removerCaracteristica,
    atualizarCaracteristica,

    // Operações
    handleConfirmarOperacao,
    handleClickConfirmDeletarVestigio,
  } = useFormEditarVestigio({
    route,
    idCaso: params.idCaso,
    idVestigio: params.idVestigio,
  })

  const isLoading =
    processandoVestigio ||
    processandoUsuarios ||
    processandoTiposVestigios ||
    processandoTiposVestigiosEspecificos

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {isLoading ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container spacing={3} style={{ marginTop: '16px' }}>
          {/* Seção: Dados de Entrada */}
          <Grid item xs={12}>

            <FormDadosEntrada
              values={values}
              touched={touched}
              errors={errors}
              currentUser={currentUser}
              onChangeUser={handleChangeNewValueByNameProperty}
              onBlur={handleBlur}
            />

          </Grid>

          {/* Seção: Sobre o Local de Coleta */}
          {!route.editar && (
            <Grid item xs={12}>
              <SecaoGenerica titulo="Sobre o Local de Coleta" spacing={2}>
                <Grid item xs={12}>
                  <FormLocalColeta
                    value={values.endOrig}
                    onChange={(newValue) => handleChangeNewValueByNameProperty('endOrig', newValue)}
                    idCaso={params.idCaso}
                  />
                </Grid>
              </SecaoGenerica>
            </Grid>
          )}

          {/* Seção: Cadeia de Custódia */}
          <Grid item xs={12}>
            <FormCadeiaCustodia
              values={values}
              touched={touched}
              errors={errors}
              usuarios={usuarios}
              onChangeUser={handleChangeNewValueByNameProperty}
              onChangeInput={handleChangeWithModification}
              onChangeDate={handleChangeCampoData}
              onBlur={handleBlur}
            />
          </Grid>

          {/* Seção: Arquivos Relacionados */}
          <Grid item xs={12}>
            <SecaoGenerica titulo="Arquivos Relacionados" spacing={2}>

              <Grid item xs={12}>
                <FileManager
                  rotaUpload="/arquivo/vestigio"
                  rotaLoadImagem="/arquivo/vestigio"
                  setArquivosPai={setArquivos}
                  arquivosIniciais={arquivosIniciais}
                  tipos={['pdf']}
                />
              </Grid>
            </SecaoGenerica>
          </Grid>

          {/* Seção: Características */}
          <Grid item xs={12}>
            <FormCaracteristicasVestigio
              route={route}
              values={values}
              touched={touched}
              errors={errors}
              handleChange={handleChange}
              handleChangeWithModification={handleChangeWithModification}
              handleChangeTipoVestigioGenerica={handleChangeTipoVestigioGenerica}
              handleChangeNewValueByNameProperty={handleChangeNewValueByNameProperty}
              caracteristicasVestigio={caracteristicasVestigio}
              adicionarCaracteristica={adicionarCaracteristica}
              removerCaracteristica={removerCaracteristica}
              atualizarCaracteristica={atualizarCaracteristica}
              tiposVestigios={tiposVestigios}
              opcoesTiposVestigiosEspecificosAtual={opcoesTiposVestigiosEspecificosAtual}
              classes={classes}
              useState={useState}
              lacreAtualHabilitado={lacreAtualHabilitado}
            />
          </Grid>

          {/* Divisor do rodapé */}
          <Grid item xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>

          {/* Botões do rodapé */}
          <Grid item xs={12}>
            <div className={classes.buttonGroup}>
              <div>
                <CustomButton
                  variant="outlined"
                  colorType="primary"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => router.history.goBack()}
                >
                  Voltar
                </CustomButton>
              </div>
              <div className={classes.deleteGroup}>
                {route.editar && (
                  <CustomButton
                    colorType="error"
                    variant="contained"
                    disabled={processandoOperacao}
                    onClick={() => setOpenDeletarVestigio(true)}
                  >
                    Excluir
                  </CustomButton>
                )}
                <CustomButton
                  colorType="secondary"
                  variant="contained"
                  disabled={isFormularioInvalido}
                  isLoading={processandoOperacao}
                  onClick={() => setOpenEspelhoConfirmacao(true)}
                >
                  {route.editar ? 'Atualizar' : 'Cadastrar'}
                </CustomButton>
              </div>
            </div>
          </Grid>
        </Grid>
      )}

      {/* Modal de Confirmação de Cadastro / Edição */}
      <ModalConfirmacao
        aberto={openEspelhoConfirmacao}
        onClose={() => setOpenEspelhoConfirmacao(false)}
        onConfirm={handleConfirmarOperacao}
        processando={processandoOperacao}
        titulo="Confirmação dos dados"
        confirmarLabel={route.editar ? 'Salvar' : 'Cadastrar'}
        cancelarLabel="Cancelar"
        maxWidth="md"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>

            <Typography variant="body2" color="textSecondary">SETOR DE ENTRADA</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              <b>
                {values.setRec
                  ? `${values.setRec.nome} - ${values.setRec.sigla} / ${values.setRec.divisao?.regional?.nome || ''}`
                  : 'NÃO INFORMADO'}
              </b>
            </Typography>

          </Grid>

          {!route.editar && (
            <Grid item xs={12}>
              <SecaoGenerica titulo="Sobre o Local de Coleta">
                <div>
                  <Typography variant="body2" color="textSecondary">ENDEREÇO</Typography>
                  <Typography variant="body1">
                    <b>{values.endOrig ? getLabelEndereco(values.endOrig) : 'NÃO INFORMADO'}</b>
                  </Typography>
                </div>
              </SecaoGenerica>
            </Grid>
          )}

          <Grid item xs={12}>
            <SecaoGenerica titulo="Cadeia de Custódia">
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Typography variant="body2" color="textSecondary">RESPONSÁVEL PELA FIXAÇÃO</Typography>
                  <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                    <b>{values.usuFix?.nome || 'NÃO INFORMADO'}</b>
                  </Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Typography variant="body2" color="textSecondary">RESPONSÁVEL PELA COLETA</Typography>
                  <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                    <b>{values.usuCol?.nome || 'NÃO INFORMADO'}</b>
                  </Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Typography variant="body2" color="textSecondary">RESPONSÁVEL PELO ACONDICIONAMENTO</Typography>
                  <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                    <b>{values.usuAcond?.nome || 'NÃO INFORMADO'}</b>
                  </Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Typography variant="body2" color="textSecondary">RESPONSÁVEL PELO TRANSPORTE</Typography>
                  <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                    <b>{values.usuTrans?.nome || 'NÃO INFORMADO'}</b>
                  </Typography>
                </Grid>
              </Grid>
            </SecaoGenerica>
          </Grid>

          {route.editar ? (
            <Grid item xs={12}>
              <SecaoGenerica titulo="Características do Vestígio">
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <Typography variant="body2" color="textSecondary">UNIDADES</Typography>
                    <Typography variant="body1"><b>{values.quantidade}</b></Typography>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography variant="body2" color="textSecondary">NÚMERO DO LACRE</Typography>
                    <Typography variant="body1" style={{ textTransform: 'uppercase' }}><b>{values.lacre || 'NÃO INFORMADO'}</b></Typography>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography variant="body2" color="textSecondary">NÚMERO DO LACRE ATUAL</Typography>
                    <Typography variant="body1" style={{ textTransform: 'uppercase' }}><b>{values.lacreAcondicionamento || 'NÃO INFORMADO'}</b></Typography>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography variant="body2" color="textSecondary">NÚMERO DE VESTÍGIO ASSOCIADO</Typography>
                    <Typography variant="body1" style={{ textTransform: 'uppercase' }}><b>{values.numeroVestigioAssociado || 'NÃO INFORMADO'}</b></Typography>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Typography variant="body2" color="textSecondary">NATUREZA PRELIMINAR (GENÉRICA)</Typography>
                    <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                      <b>{values.tiposGens?.map((tipo) => tipo.nome).join(', ') || 'NÃO INFORMADO'}</b>
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Typography variant="body2" color="textSecondary">NATUREZA PRELIMINAR (ESPECÍFICA)</Typography>
                    <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                      <b>{values.tiposEsps?.map((tipo) => tipo.nome).join(', ') || 'NÃO INFORMADO'}</b>
                    </Typography>
                  </Grid>
                  {values.tamanhoObjeto && (
                    <Grid item md={6} xs={12}>
                      <Typography variant="body2" color="textSecondary">TAMANHO DO OBJETO</Typography>
                      <Typography variant="body1" style={{ textTransform: 'uppercase' }}><b>{values.tamanhoObjeto}</b></Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary">DESCRIÇÃO</Typography>
                    <Typography variant="body1" style={{ textTransform: 'uppercase' }}><b>{values.descricao}</b></Typography>
                  </Grid>
                </Grid>
              </SecaoGenerica>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <SecaoGenerica titulo="Vestígios a serem Adicionados">
                {isMobile ? (
                  caracteristicasVestigio.map((caracteristica, index) => (
                    <Card key={index} variant="outlined" style={{ marginBottom: '12px', padding: '16px' }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>VESTÍGIO #{index + 1}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="textSecondary">UNIDADES</Typography>
                          <Typography variant="body1"><b>{caracteristica.quantidade}</b></Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="textSecondary">NÚMERO DO LACRE</Typography>
                          <Typography variant="body1" style={{ textTransform: 'uppercase' }}><b>{caracteristica.lacre || 'NÃO INFORMADO'}</b></Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">NATUREZAS (GENÉRICA / ESPECÍFICA)</Typography>
                          <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                            <b>
                              {`${caracteristica.tiposGens?.map((tipo) => tipo.nome).join(', ') || 'NÃO INFORMADA'} / ${caracteristica.tiposEsps?.map((tipo) => tipo.nome).join(', ') || 'NÃO INFORMADA'}`}
                            </b>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Card>
                  ))
                ) : (
                  <List disablePadding>
                    {caracteristicasVestigio.map((caracteristica, index) => {
                      const gen = caracteristica.tiposGens?.map((t) => t.nome).join(', ') || 'NÃO INFORMADA'
                      const esp = caracteristica.tiposEsps?.map((t) => t.nome).join(', ') || 'NÃO INFORMADA'

                      return (
                        <div key={index}>
                          <ListItem style={{ padding: '8px 0' }}>
                            <ListItemText
                              primary={
                                <Typography variant="body1">
                                  <b>Vestígio #{index + 1}:</b> Lacre <b>{caracteristica.lacre || 'NÃO INFORMADO'}</b> — <b>{caracteristica.quantidade}</b> {caracteristica.quantidade > 1 ? 'unidades' : 'unidade'}
                                </Typography>
                              }
                              secondary={
                                <Typography variant="body2" color="textSecondary">
                                  Natureza: {gen.toUpperCase()} / {esp.toUpperCase()}
                                </Typography>
                              }
                            />
                          </ListItem>
                          {index < caracteristicasVestigio.length - 1 && <Divider />}
                        </div>
                      )
                    })}
                  </List>
                )}
              </SecaoGenerica>
            </Grid>
          )}
        </Grid>
      </ModalConfirmacao>

      {/* Modal de Exclusão */}
      <ModalConfirmacao
        aberto={openDeletarVestigio}
        onClose={() => setOpenDeletarVestigio(false)}
        onConfirm={handleClickConfirmDeletarVestigio}
        processando={processandoOperacao}
        titulo="Excluir Vestígio"
        confirmarLabel="Confirmar"
        cancelarLabel="Cancelar"
        confirmarColor="error"
      >
        <Typography variant="body1">
          Tem certeza que deseja deletar este vestígio? Esta ação não poderá ser desfeita.
        </Typography>
      </ModalConfirmacao>
    </Page>
  )
}
export default FormEditarVestigio
